import { ModalPanelProps } from '../DashboardModal';
import React, { PureComponent } from 'react';
import { Button, Form, Input, notification } from 'antd';
import { Flex } from 'app/components/common/Flex';
import { FlightId, FlightIdListRequestDto } from 'app/model/CORE';
import { ServiceFactory } from 'app/service/ServiceFactory';
import AppContext from 'app/common/context/AppContext';

interface BookSlotValues {
    aircraftId: string;
}

interface BookSlotPanelProps extends ModalPanelProps {
    onSuccess: (flightId: FlightId) => void;
}

export class BookSlotPanel extends PureComponent<BookSlotPanelProps> {
    constructor(props) {
        super(props);
        this.state = {
            flightId: undefined,
        };
    }

    handleFinish = (v: BookSlotValues) => {
        const request: FlightIdListRequestDto = {
            dataset: AppContext.getDataset(),
            callsign: v.aircraftId,
            // TODO, use regulated period ? monitored period ?
            eobtPeriod: AppContext.getTodayPeriod(),
        };
        ServiceFactory.coreService()
            .getFlightIds(request)
            .then(reply => {
                if (reply.error) {
                    notification.error({
                        message: 'Error retrieving flight',
                        description: reply.error + '',
                        duration: 0,
                    });
                } else if (reply.data.length === 0) {
                    notification.error({ message: 'Could not find flight: ' + v.aircraftId, duration: 0 });
                } else if (reply.data.length === 1) {
                    this.props.onSuccess(reply.data[0]);
                    this.props.onClose();
                } else {
                    // TODO : Multiple flights corresponds to given ID, ask user to choose
                    console.log('Multiple flights ! ', reply.data);
                    notification.info({ message: 'Multiple flights for aircraftID !' });
                }
            })
            .catch(error => {
                console.log('error !', error);
                notification.error({ message: 'Error retrieving flight', description: error.message, duration: 0 });
            });
    };

    render() {
        return (
            <Form
                style={{ padding: '1em' }}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 12 }}
                onFinish={this.handleFinish}>
                <Form.Item
                    label="Aircraft Id:"
                    name="aircraftId"
                    rules={[{ required: true, message: 'Please enter an aircraft id' }]}>
                    <Input />
                </Form.Item>
                <Flex style={{ justifyContent: 'center' }}>
                    <Button htmlType="submit">Submit</Button>
                </Flex>
            </Form>
        );
    }
}
